export default "__VITE_ASSET__Dffwfqkw__"